import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDzDiYrB4hzkElsTxKsPhN6_0wnOKpufHc",
  authDomain: "attirly-app.firebaseapp.com",
  projectId: "attirly-app",
  storageBucket: "attirly-app.appspot.com",
  messagingSenderId: "931694596078",
  appId: "1:931694596078:web:d4bbe320526d87641908ff",
  measurementId: "G-DWZFY292D0",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
